<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeContasAPagarMostragem from "./LinhaDeContaAPagarMostragem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
    "pagamentoNovo",
    "notasFiscaisRecebidas",
    "adiantamentos",
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
    "update:alteraPagamentoNovo"
]);

//==================================================================//
//==================== Altera Conta a Pagar ========================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    update.id = props?.contaAPagar?.id;
    emits('update:alteraContaAPagar',update);

};

//==================================================================//
//===================== Altera Pagamento Novo ======================//
//==================================================================//

const alteraPagamentoNovo = (updateContaAPagar = {}, updatePagamentoNovo)=>{

    let update = {
        contaAPagar:{
            id: props?.contaAPagar?.id,
            ...updateContaAPagar,
        },
        pagamentoNovo: {
            id: props?.pagamentoNovo?.id,
            ...updatePagamentoNovo,
        }
    }

    emits('update:alteraPagamentoNovo',update);

};


</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeContasAPagarMostragem
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="props?.contaAPagar"
            :pagamentoNovo="props?.pagamentoNovo"
            :notasFiscaisRecebidas="props?.notasFiscaisRecebidas"
            :adiantamentos="props?.adiantamentos"
            @update:alteraContaAPagar="alteraContaAPagar"
            @update:alteraPagamentoNovo="alteraPagamentoNovo"
        ></LinhaDeContasAPagarMostragem>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: contents;
}

.c-table__row-group:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

</style>
